import React, { SyntheticEvent } from 'react';
import MessageService from '@services/Message.service';
import IGuardedLink from './IGuardedLink';
import * as style from './GuardedLinkStyle.module.scss'
import {
  EGeneralMessageLink,
  TGeneralMessageLink
} from '@apps/MessageApp/components/PropsPassedMessage/IPropsPassedMessage';
import { classNames } from '@features/utils/reactFunctions';
import { getGuardMessage } from '@apps/MessageApp/features/helpers/functions';
import AcknowledgeBox from '@apps/MessageApp/components/AcknowledgeBox/AcknowledgeBox';
import { TReducers } from '@features/reducers';
import { connect } from 'react-redux';
import * as elements from '@appStyles/_elements.module.scss';

const GuardedLink: React.FunctionComponent<IGuardedLink> = (props) => {
 
  const [errorMessageState, setErrorMessageState] = React.useState('');

  const getGuardSpecificAction = (guard: string) => {
    if (guard === 'not_investing') {
      return () => MessageService.checkIfInvested(props.investorId)
        .then(() => {
          window.location.href = `/profile/${props.slug}`;
        })
        .catch((err) => {
          setErrorMessageState(getGuardMessage(Object.keys(err.response.data.errors)[0]) || '');
        });
    }

    return;
  };

  const handleGuardedClick = (e: SyntheticEvent, link: TGeneralMessageLink) => {
    if (link.guard) {
      e.preventDefault();

      getGuardSpecificAction(link.guard)!();
    }

    return;
  };

  const renderUrl = (link: TGeneralMessageLink): JSX.Element => {
    let className = style.link;
    if (link.type === EGeneralMessageLink.button) {
      className = classNames(elements.btn, elements.btnSuccess);
    }

    return (
      <>
        <a className={className} href={link.url} key={link.label} onClick={e => handleGuardedClick(e, link)}>
          {link.label}
        </a>
        {errorMessageState && <AcknowledgeBox
          closeLightbox={() => setErrorMessageState('')}
          text={errorMessageState}
          isVisible={!!errorMessageState}
        />}
      </>
    );
  };

  return (
    renderUrl(props.link)
  );
};

const mapStateToProps = (store: TReducers) => ({
  investorId: store.userInfo.investor_id,
  slug: store.userInfo.nickname,
});

export default connect(mapStateToProps)(GuardedLink);
